export function formatDateTimeWithSeconds(value) {
  if (!value) return '-'
  const d = new Date(value)
  if (isNaN(d)) return '-'
  const dd = String(d.getDate()).padStart(2, '0')
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const yyyy = d.getFullYear()
  const HH = String(d.getHours()).padStart(2, '0')
  const MM = String(d.getMinutes()).padStart(2, '0')
  const SS = String(d.getSeconds()).padStart(2, '0')
  return `${dd}/${mm}/${yyyy} ${HH}:${MM}:${SS}`
}